import {createContext} from 'react'

function noop() {
}

export const ScreenDesignerContextNew = createContext({
    designerType: 'screen',
    screenValues: {},
    resolution: '',
    lists: [],
    selectedComponent: {},
    suggestions: {},
    listStorage: [],
    uploadedImages: []
});